module.exports = __webpack_public_path__ + "static/media/Comp-1.00033f33.gif";